import React from 'react';
import HeaderBanner from '../../../common/HeaderBanner';
import i18n from '../../../../i18n';
import { RechargeForm } from './components/recharge/RechargeForm';
import { withRouter } from '../../../../hoc/withRouter';

class WalletRecharge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <div className="mze-page">
          <HeaderBanner
            title={i18n.t('wallet_recharge')}
            subtitle={i18n.t('wallet_recharge_subtitle')}
          />
          <div className="mze-container">
            <div className="mze-recharge-wrap">
              <RechargeForm navigate={this.props.navigate} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default withRouter(WalletRecharge);
